import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import { MdDeleteForever } from "react-icons/md";
import numberbeautify from "../../utils/numberbeautify";
import '../../component/css/onprintcss.css';
import getitemaction from "../../context/action/returnbybarcode/getitemaction";
import Sellinvoicedetailmodal from "../sell/sellinvoicedetailmodal";
import Sellitemprint from "../sell/sellitemprint";
import '../../component/css/onprintcss.css';
import moment from "moment/moment";

const Returnbybarcode = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    const [barcode,setbarcode]=useState();
    const [show,setshow]=useState(false);
    const [invoice_detail, setinvoice_detail] = useState();
    const [invoiceno, setinvoiceno] = useState(0);

    const printit=(invoiceno)=>{
        setinvoiceno(invoiceno);
        setTimeout(() => {
          window.print();
        }, 500);
      }
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
        <Sellitemprint username={initState.token.username} items={invoice_detail?invoice_detail.items:[]} invoiceno={invoiceno} />
        <div className="print_hide">
        <Sellinvoicedetailmodal
        show={show}
        setshow={setshow}
        invoice_detail={invoice_detail}
        setinvoice_detail={setinvoice_detail}
        printit={printit}
      />
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">گەڕانەوە</h1>
          <p className="text-sm text-slate-400 mt-0.5">گەڕانەوەی کاڵا بە باڕکۆد</p>
        </div>
      </div>
      <div className="bg-gray-400 border border-gray-500 rounded-xl p-6 mb-6 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-4 items-end">
            {/* <div className="col-span-4 lg:col-span-3 relative"> */}
              {/* Item/Barcode Input */}
              <div className="w-full">
                <label
                  className="block text-base font-medium text-white mb-1 text-right"
                  for="grid-barcode"
                >
                  باڕکۆد
                </label>
                <input
                  className={
                    "w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                  }
                  id="grid-barcode"
                  type="text"
                  value={barcode}
                  onChange={(val) => setbarcode(val.target.value)}
                  autoFocus
                  onKeyDown={(key) => {
                    if (key.key == "Enter") {
                      getitemaction(barcode)(recaller)(setrecaller)(initDispatch)(
                        setbarcode
                      );
                    }
                  }}
                />
              </div>
            </div>
        </div>
          {initState.returnbybarcode.length>0?
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <h2 className="text-base font-semibold text-slate-800">لیستی وەسڵی فرۆشراو</h2>
            </div>

            {/* Table */}
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ژمارەی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    بەرواری وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی کاڵای سەر وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی نرخی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی نرخی فرۆشراو
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    تێبینی
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {initState.returnbybarcode.map((lis, index) => (
                  <tr
                    key={index}
                    className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                    onClick={() => {
                        setinvoice_detail(lis);
                        setshow(true);
                      }}
                  >
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.sell_invoice_id}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {moment(lis.sell_invoice_date).format('YYYY-MM-DD hh:mm A')}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(
                          lis?.items?.reduce(
                            (a, v) => (a = Number(a) + Number(v.item_qty)),
                            0
                          )
                        )}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(lis?.items?.reduce(
                            (a, v) => (a = Number(a) + (Number(v.item_qty)*Number(v.item_price))),
                            0
                          ))}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {numberbeautify(lis?.items?.reduce(
                            (a, v) => (a = Number(a) + (Number(v.item_qty)*Number(v.item_sell_price))),
                            0
                          ))}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.sell_invoice_note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :null}
          </div>
    </div>
  )
}

export default Returnbybarcode